import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/guards/auth.guard';
import { ReportBuilderPickerComponent } from './pages/report-builder-picker/report-builder-picker.component';
import { ReportBuilderBasicComponent } from './pages/report-builder-basic/report-builder-basic.component';
import { ReportBuilderAggregateComponent } from './pages/report-builder-aggregate/report-builder-aggregate.component';

const routes: Routes = [
  { path: 'report-builder', component: ReportBuilderPickerComponent, canActivate: [AuthGuard] },
  { path: 'report-builder/aggregate', component: ReportBuilderAggregateComponent, canActivate: [AuthGuard] },
  { path: 'report-builder/basic/:entity', component: ReportBuilderBasicComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportBuilderRoutingModule { }
